import React from "react";
import { Stack, Box, Typography } from "@mui/material";

const InfoRow = ({ icon, label, value }) => (
  <Stack direction="row" alignItems="center" spacing={1.5}>
    <Box sx={{ color: "text.secondary", display: "flex" }}>{icon}</Box>
    <Box>
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        lineHeight={1}
      >
        {label}
      </Typography>
      <Typography variant="body2" fontWeight="500">
        {value || "N/A"}
      </Typography>
    </Box>
  </Stack>
);

export default InfoRow;
